/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlCategoryDefinition
 */
export interface ControlCategoryDefinition {
    /**
     * 
     * @type {string}
     * @memberof ControlCategoryDefinition
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ControlCategoryDefinition
     */
    title: string;
}

/**
 * Check if a given object implements the ControlCategoryDefinition interface.
 */
export function instanceOfControlCategoryDefinition(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "title" in value;

    return isInstance;
}

export function ControlCategoryDefinitionFromJSON(json: any): ControlCategoryDefinition {
    return ControlCategoryDefinitionFromJSONTyped(json, false);
}

export function ControlCategoryDefinitionFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlCategoryDefinition {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'title': json['title'],
    };
}

export function ControlCategoryDefinitionToJSON(value?: ControlCategoryDefinition | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'title': value.title,
    };
}

